/**
 * MyOrder
 */
import { mapState, mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import countdown from 'countdown';

import SharedHeader from '@/components/SharedHeader.vue';
import SharedFooter from '@/components/SharedFooter.vue';
import WayFindBar from '@/components/WayFindBar.vue';
import Footer from '@/components/Footer.vue';
import Aside from '@/components/Aside.vue';
import Spinner from '@/components/Spinner.vue';
import OrderList from '@/components/OrderList.vue';

import { OrderMixin } from '@/scripts/Mall/Order/Order.mixin';
import { OrderDetailMixin } from '@/scripts/Mall/OrderDetail/OrderDetail.mixin';
import { LOADING_MESSAGE } from './MyOrder.constants';

export default {
  name: 'MyOrder',

  mixins: [OrderMixin, OrderDetailMixin],

  components: {
    SharedHeader,
    SharedFooter,
    WayFindBar,
    Footer,
    Aside,
    Spinner,
    OrderList,
  },

  data: () => {
    return {
      timeNow: null,
      MyOrderList: [],
      loadingMessage: LOADING_MESSAGE,
    };
  },

  computed: {
    ...mapState('Mall/MyOrder', {
      ms_isRequest: 'isRequest',
    }),

    ...mapGetters('Mall/MyOrder', {
      mg_MyOrderList: 'MyOrderList',
    }),

    c_MyOrderListAll() {
      return this.MyOrderList;
    },

    c_MyOrderListPending() {
      return _.filter(
        this.MyOrderList,
        (order) =>
          'isNotStarted' === order.i_orderDueStatus ||
          'isOverDueStartTime' === order.i_orderDueStatus
      );
    },

    c_MyOrderListDone() {
      return _.filter(this.MyOrderList, (order) => 'isFinished' === order.i_orderDueStatus);
    },

    c_MyOrderListInvalid() {
      return _.filter(this.MyOrderList, (order) => 'isOverDueEndTime' === order.i_orderDueStatus);
    },
  },

  methods: {
    ...mapActions('Mall/MyOrder', {
      ma_getMarketTradeList: 'getMarketTradeList',
    }),

    makeMyOrderList() {
      this.MyOrderList = _.map(this.mg_MyOrderList, (order) => {
        let myOrder = {
          ...order,
          i_orderDueStatus: '',
          i_myOrderId: 'order' === order.recordType ? order.orderId : order.tradeId,
          i_realPrice: undefined !== order.realPrice ? order.realPrice : order.goodsPrice,
          name: this.makeCpaGoodsDetailName(order.name),
        };
        if (1 === myOrder.tradeStatus) {
          myOrder = {
            ...myOrder,
            i_orderDueStatus: 'isFinished',
          };
        } else if (-1 === myOrder.tradeStatus) {
          myOrder = {
            ...myOrder,
            i_orderDueStatus: 'isOverDueEndTime',
          };
        } else if (0 === myOrder.tradeStatus) {
          const isPresellBalance =
            myOrder.isPresellTrade && 0 === myOrder.preSellType && 1 === myOrder.preSellStatus;
          const isNotStarted =
            isPresellBalance && myOrder.dueStartTime && this.timeNow < myOrder.dueStartTime;
          myOrder = {
            ...myOrder,
            i_orderDueStatus: isNotStarted ? 'isNotStarted' : 'isOverDueStartTime',
          };
          if (myOrder.dueStartTime) {
            myOrder = {
              ...myOrder,
              dueStartTimeSpan: null,
              dueStartTimeCountdownId: countdown(
                (timeSpan) => {
                  myOrder.dueStartTimeSpan = timeSpan;
                },
                myOrder.dueStartTime,
                countdown.DAYS | countdown.HOURS | countdown.MINUTES | countdown.SECONDS
              ),
              objStrDueStartTime: this.getObjStrDueTime(myOrder.dueStartTime),
            };
          }
          if (myOrder.dueEndTime) {
            myOrder = {
              ...myOrder,
              dueEndTimeSpan: null,
              dueEndTimeCountdownId: countdown(
                (timeSpan) => {
                  myOrder.dueEndTimeSpan = timeSpan;
                },
                myOrder.dueEndTime,
                countdown.DAYS | countdown.HOURS | countdown.MINUTES | countdown.SECONDS
              ),
              objStrDueEndTime: this.getObjStrDueTime(myOrder.dueEndTime),
            };
          } /* else if (myOrder.dueEndTime && myOrder.dueEndTime < this.timeNow) {
            myOrder = {
              ...myOrder,
              i_orderDueStatus: 'isOverDueEndTime',
            };
          } */
        }
        return myOrder;
      });
    },

    async _MyOrderListCreated() {
      await this.ma_getMarketTradeList();
      this.timeNow = new Date().getTime();
      this.makeMyOrderList();
    },
  },

  created() {
    this._MyOrderListCreated();
  },

  mounted() {
    window.scrollTo(0, 0);
  },

  beforeDestroy() {
    for (let i = 0; i < this.MyOrderList.length; i++) {
      clearInterval(this.MyOrderList[i].dueStartTimeCountdownId);
      clearInterval(this.MyOrderList[i].dueEndTimeCountdownId);
    }
  },
};
